export const selectedClassName = 'selected';